import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper"
import { openWelcome } from "store/agenda/action"


const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let respp;
      const response = yield call(
        async (url = process.env.REACT_APP_ADMIN+"/login", data = user) => {
          // Default options are marked with *
          const response = await fetch(url, {
            method: 'POST', 
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data), // body data type must match "Content-Type" header
          })
           respp = await response.json();
          console.log("saga:", respp.document.Email);
        })
        if (respp.document?.Email) {
          console.log("Attempting to save to localStorage:", respp.document);
          localStorage.setItem("authUser", JSON.stringify(respp.document));
          console.log("Saved to localStorage, verifying:", localStorage.getItem("authUser"));
          yield put(loginSuccess(respp.document));
          yield put(openWelcome());
           history.push("/page/lobby")
        } else {
          console.log("Email not found in response:", respp);
          console.log("login error:", response);
          localStorage.removeItem("authUser");
          localStorage.removeItem("activityArr");
          yield put(apiError(response.mssg))
        }
        return respp // parses JSON response into native JavaScript objects
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
       history.push("/page/lobby")
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
       history.push("/page/lobby")
    }
    // history.push("/page/lobby")
    // window.location.href="/page/lobby"
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("notificationToken")
    localStorage.removeItem("activityArr")
    // openWelcome()
    // if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
    //   const response = yield call(fireBaseBackend.logout)
    //   yield put(logoutUserSuccess(response))
    // }
    CometChatWidget.logout().then(response => {
      // User successfully logged out.
    // Perform any clean up if required.
    console.log("chat logout success!");
  });
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
    // window.location.href="/page/lobby"
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
